export default function getUsers(state) {
  return state.users.entities;
}
